module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.introOpen ? 'intro-open' : '', _vm.modalOpen ? 'modal-open' : '', _vm.$route.name],
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.name == 'home') ? _c('site-intro') : _vm._e(), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-184e5b7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 116
// module chunks = 2